module.exports = __webpack_public_path__ + "img/nodata.60990402.svg";